module.exports = __webpack_public_path__ + "img/helen-portrait.c1c980fd.png";